module.exports = __webpack_public_path__ + "media/images/features/refund/bg-faq-624209e7c0cecbf449967a7f7147a833.png";